import { apiService } from "./apiService";

export const applicationsMetaService = {
  getAllByTenant: (tenantId: string) =>
    apiService.get(`/api/Applications/tenant/${tenantId}`, {}, 'backend'),

  create: (applicationData: any) =>
    apiService.post(`/api/Applications/create`, applicationData, 'backend'),

  GetBySpacode: (spacode: string) =>
    apiService.post(`/api/Applications/spacode/${spacode}`, {}, 'backend'),

  edit: (id: string) =>
    apiService.post(`/api/Applications/edit/${id}`, {}, 'backend'),

  update: (applicationData: any) =>
    apiService.post(`/api/Applications/update`, applicationData, 'backend'),

  delete: (id: string) =>
    apiService.post(`/api/Applications/delete/${id}`, {}, 'backend'),
};